/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions

==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'
import router from '@/router'

export default {

  refreshUserObject ({commit}) {
    return new Promise((resolve, reject) => {

      jwt.refreshUserObject()
        .then(response => {
          if (response.data.data) {

            commit('UPDATE_USER_INFO', response.data.data, {root: true})

            return resolve(response.data.data)
          }

          reject(response.data)
        })
        .catch(exception => reject(exception))
    })
  },

  refreshCourseObject ({commit}) {
    return new Promise((resolve, reject) => {

      jwt.refreshCourseObject()
        .then(response => {
          if (response.data.data) {

            let courseInfo = response.data.data

            if (response.data.data === 'none') {
              localStorage.removeItem('courseInfo')
              courseInfo = null
            }

            if (response.data.data !== 'none') {
              courseInfo.selected = true
            }

            commit('UPDATE_COURSE_INFO', courseInfo, {root: true})

            return resolve(response.data.data)
          }

          reject(response.data)
        })
        .catch(exception => reject(exception))
    })
  },
  // JWT
  loginJWT ({commit}, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.username, payload.password, payload.recaptcha)
        .then(response => {

          // If there's user data in response
          if (response.data.data) {
            // Navigate User to homepage
            const data = response.data.data

            // Set accessToken
            localStorage.setItem('accessToken', data.accessToken)
            localStorage.setItem('refreshToken', data.refreshToken)

            if (data.user.first_name) {
              data.user.full_name = `${data.user.first_name} ${data.user.last_name}`
            }

            // Update user details
            commit('UPDATE_USER_INFO', data.user, {root: true})

            // Set bearer token in axios
            commit('SET_BEARER', data.accessToken)

            router.push('/dashboard')

            resolve(response)
          } else {
            reject({message: 'Wrong Username or Password'})
          }

        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => {
        resolve(response)
      }).catch((exception) => {
        throw exception
      })
    })
  }
}
